// React
import { memo } from "react";

// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// Constants
import { initialDataWithPagination } from "services/api/consts";
import { CALCULATION_TOLL_SEARCH_COLUMNS } from "./consts";

// Types
import { TollSearchResultsProps } from "./types";

const TollSearchResults: React.FC<TollSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;


  return (
    <>
      <TableSearch
        columns={CALCULATION_TOLL_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(TollSearchResults);
